import { ulid } from 'ulid';

import type {
	CreateParkingSessionInput,
	ChangeParkingSessionPlateNumberInput
} from '@/graphql/generated';

export interface ParkingSessionFormSubmitData {
	parkingSessionId?: string;
	plateNumber: string;
	ticketId?: string | null;
	vehicleId?: string;
}

/**
 * Generates an idempotent parking session ID using ULID.
 * Should be called once per form render via useMemo.
 */
export const generateIdempotentParkingSessionId = (): string => ulid();

/**
 * Builds the input payload for creating a new parking session.
 */
export const buildCreateParkingSessionInput = (
	formData: ParkingSessionFormSubmitData,
	idempotentParkingSessionId: string
): CreateParkingSessionInput => {
	return {
		parkingSessionId: idempotentParkingSessionId,
		plateNumber: formData.plateNumber,
		ticketId: formData.ticketId || undefined
	};
};

/**
 * Builds the input payload for changing a parking session's plate number.
 */
export const buildChangePlateNumberInput = (
	parkingSessionId: string,
	plateNumber: string
): ChangeParkingSessionPlateNumberInput => {
	return {
		parkingSessionId,
		plateNumber
	};
};

/**
 * Maps parking session data to form data for edit mode.
 */
export const mapParkingSessionToFormData = (
	plateNumber?: string | null,
	vehicleId?: string | null
): ParkingSessionFormSubmitData => {
	return {
		plateNumber: plateNumber ?? '',
		vehicleId: vehicleId ?? undefined
	};
};
